import Vue from 'vue'
import Router from 'vue-router'
import store from "@/store/store";
import Service from "@/service/api";
import { isTokenExpired } from "@/router/middlewares/auth-guard";

// Mockup & Common
const MLogin = () => import('@/pages/view/Login')
const UserManual = () => import('@/pages/view/UserManual')

// Admin
const ATheContainer = () => import('@/components/admin/TheContainer')
const AReportList = () => import('@/pages/admin/ReportList')
const AReportDetail = () => import('@/pages/admin/ReportDetail')
const ABuildingManagement = () => import('@/pages/admin/BuildingManagement')
const AJobTypeManagement = () => import('@/pages/admin/JobTypeManagement')
const AUsersList = () => import('@/pages/admin/usersList')
const AAdminDashboard = () => import('@/pages/admin/AdminDashboard')

// User
const Userhomepage = () => import('@/pages/user/mainuser')
const Ucontainer = () => import('@/components/user/Ucontainer')

// Supervisor
const STheContainer = () => import('@/components/supervisor/TheContainer')
const SUsersList = () => import('@/pages/supervisor/usersList')
const SReportList = () => import('@/pages/supervisor/ReportList')
const SReportDetail = () => import('@/pages/supervisor/ReportDetail')
const SJobTypeManagement = () => import('@/pages/supervisor/JobTypeManagement')
const SAdminDashboard = () => import('@/pages/supervisor/SupervisorDashboard')

// Technician
const TReportDetail = () => import('@/pages/technician/ReportDetail')
const TTheContainer = () => import('@/components/technician/TheContainer')
const TReportList = () => import('@/pages/technician/ReportList')

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: () => {
        try {
          const stored = localStorage.getItem('smartfix_preferred_role') || (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).role);
          if (stored === 'supervisor') return '/supervisor';
          if (stored === 'technician') return '/technician';
          if (stored === 'user') return '/user';
        } catch (e) {
          // fallback to default role
        }
        return '/admin';
      },
      name: 'Mockup',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Mlogin',
          component: MLogin,
          meta: { requiresAuth: false }
        },
        {
          path: 'user',
          redirect: 'user/mainuser',
          name: 'MHome',
          component: Ucontainer,
          meta: { roles: ['user'] },
          children: [
            {
              path: 'mainuser',
              name: 'Userhomepage',
              component: Userhomepage
            },
            {
              path: 'manual',
              name: 'UManual',
              component: UserManual
            },
          ]
        },
        {
          path: 'admin',
          redirect: 'admin/dashboard',
          name: 'MHome',
          component: ATheContainer,
          meta: { roles: ['admin'] },
          children: [
            {
              path: 'dashboard',
              name: 'ADashboard',
              component: AAdminDashboard
            },
            {
              path: 'reportlist',
              name: 'AReportList',
              component: AReportList
            },
            {
              path: 'reportlist/:ticket_id',
              name: 'AReportDetail',
              component: AReportDetail,
              props: true,
            },
            {
              path: 'job-type',
              name: 'AJobTypeManagement',
              component: AJobTypeManagement,
              props: true,
            },
            {
              path: 'building',
              name: 'ABuildingManagement',
              component: ABuildingManagement,
              props: true,
            },
            {
              path: 'UsersList',
              name: 'AUsersList',
              component: AUsersList,
            },
            {
              path: 'manual',
              name: 'AManual',
              component: UserManual
            },
          ]
        },
        {
          path: 'supervisor',
          redirect: 'supervisor/reportlist',
          name: 'MHome',
          component: STheContainer,
          meta: { roles: ['supervisor'] },
          children: [
            {
              path: 'dashboard',
              name: 'SDashboard',
              component: SAdminDashboard
            },
            {
              path: 'reportlist',
              name: 'SReportList',
              component: SReportList
            },
            {
              path: 'reportlist/:ticket_id',
              name: 'SReportDetail',
              component: SReportDetail,
              props: true,
            },
            {
              path: 'UsersList',
              name: 'SUsersList',
              component: SUsersList,
            },
            {
              path: 'job-type',
              name: 'SJobTypeManagement',
              component: SJobTypeManagement,
              props: true,
            },
            {
              path: 'manual',
              name: 'SManual',
              component: UserManual
            },
          ]
        },
        {
          path: 'technician',
          redirect: 'technician/reportlist',
          name: 'MHome',
          component: TTheContainer,
          meta: { roles: ['technician'] },
          children: [
            {
              path: 'reportlist',
              name: 'TReportList',
              component: TReportList
            },
            {
              path: 'reportlist/:ticket_id',
              name: 'TReportDetail',
              component: TReportDetail,
              props: true,
            },
            {
              path: 'manual',
              name: 'TManual',
              component: UserManual
            },
          ]
        }
      ]
    }
  ]
})

const roleDefaultRoute = {
  admin: '/admin',
  supervisor: '/supervisor',
  technician: '/technician',
  user: '/user'
};

const roleCredentialsMap = {
  admin: { username: 'admin', password: '123456' },
  supervisor: { username: 'super', password: '123456' },
  technician: { username: 'tech', password: '123456' },
  user: { username: 'user', password: '123456' }
};

const isTestLoginEnabled = process.env.NODE_ENV === 'development';

router.beforeEach(async (to, from, next) => {
  let accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");

  // 1. ดึง User Role จาก localStorage
  let userRole = null;
  const userStored = localStorage.getItem("user");
  if (userStored) {
    try {
      userRole = JSON.parse(userStored).role;
    } catch (e) {
      userRole = null;
    }
  }

  if (isTestLoginEnabled) {
    // Development-only role preview and automatic test login.
    if (to.path === '/login' || to.name === 'Mlogin') {
      const targetRole = userRole || localStorage.getItem('smartfix_preferred_role') || 'admin';
      if (!accessToken || isTokenExpired(accessToken)) {
        try {
          const creds = roleCredentialsMap[targetRole] || roleCredentialsMap.admin;
          await store.dispatch('auth/testSignIn', creds);
        } catch (err) {
          console.error("Auto login on /login route failed:", err);
        }
      }
      return next(roleDefaultRoute[targetRole] || '/admin');
    }

    if (!accessToken || isTokenExpired(accessToken)) {
      const targetRole = userRole || localStorage.getItem('smartfix_preferred_role') || 'admin';
      try {
        const creds = roleCredentialsMap[targetRole] || roleCredentialsMap.admin;
        await store.dispatch('auth/testSignIn', creds);
        accessToken = localStorage.getItem('accessToken');
        const updatedUser = localStorage.getItem('user');
        if (updatedUser) userRole = JSON.parse(updatedUser).role;
      } catch (error) {
        console.error("Auto test login failed:", error);
      }
    }

    const requiredRoles = to.matched.find(record => record.meta.roles)?.meta.roles;
    if (requiredRoles && userRole && !requiredRoles.includes(userRole)) {
      const targetRole = requiredRoles[0];
      const creds = roleCredentialsMap[targetRole];
      if (creds) {
        try {
          await store.dispatch('auth/testSignIn', creds);
          localStorage.setItem('smartfix_preferred_role', targetRole);
          return next();
        } catch (err) {
          console.error("Auto switch role on route enter failed:", err);
        }
      }
    }

    return next();
  }

  if (to.path === '/login' || to.name === 'Mlogin') {
    if (accessToken && !isTokenExpired(accessToken)) {
      return next(roleDefaultRoute[userRole] || '/user');
    }
    return next();
  }

  if (!accessToken && !refreshToken) {
    return next('/login');
  }

  if (isTokenExpired(accessToken) || !accessToken) {
    try {
      const response = await Service.auth('refresh-token', { refreshToken });
      accessToken = response.data.accessToken;
      localStorage.setItem("accessToken", accessToken);
    } catch (error) {
      console.error("Auto Login Failed:", error);
      store.dispatch('auth/logout');
      return next('/login');
    }
  }

  const requiredRoles = to.matched.find(record => record.meta.roles)?.meta.roles;
  if (requiredRoles && !requiredRoles.includes(userRole)) {
    return next(roleDefaultRoute[userRole] || '/login');
  }

  next();
});

export default router;
